<template>
  <div class="bookmark-wrapper d-flex align-items-center flex-shrink-0">
    <div v-if="showMiaLogo" class="mia-logo-wrapper">
      <a class="nav-link p-0 d-flex align-items-center" href="/">
        <img src="/app-assets/images/myAccLogo.png" class="mia-logo" alt="">
      </a>
    </div>
    <ul v-if="showToggle" class="nav navbar-nav d-xl-none me-50">
      <li class="nav-item">
        <a class="nav-link menu-toggle p-0 d-flex align-items-center justify-content-center menu-toggle-icon-wrap" href="#">
          <i class="fas fa-bars menu-toggle-icon"></i>
        </a>
      </li>
    </ul>
    <div v-if="showCompanyName" class="company-name-wrapper ms-50">
      <h4 class="desktop-company-name mb-0">{{ company.name }}</h4>
      <h5 :title="company.name" v-if="company && company.name" class="mobile-company-name mb-0">
        {{ shortenedCompanyName }}
      </h5>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'NavbarLeft',
  props: {
    company: {
      type: Object,
      required: true
    },
    showMiaLogo: {
      type: Boolean,
      default: false
    },
    showToggle: {
      type: Boolean,
      default: false
    },
    showCompanyName: {
      type: Boolean,
      default: false
    },
    isExpanded: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const shortenedCompanyName = computed(() => {
      const name = props.company && props.company.name ? props.company.name : '';
      if (name.length > 12) {
        return name.slice(0, 12) + '…';
      }
      return name;
    });

    return { shortenedCompanyName };
  }
};
</script>

<style scoped>
.mia-logo-wrapper {
  height: 40px;
  display: flex;
  align-items: center;
  padding-right: 12px;
  border-right: 1px solid #f3f4f6;
  margin-right: 12px;
}
.mia-logo { width: 150px; object-fit: contain; }

.menu-toggle-icon-wrap { width: 32px; height: 32px; }
.menu-toggle-icon { font-size: 1.2rem; color: #6366f1; }

.company-name-wrapper {
  overflow: hidden;
  display: flex;
  align-items: center;
}
.desktop-company-name {
  margin: 0;
  white-space: nowrap;
}
.mobile-company-name {
  display: none;
  font-size: 0.95rem;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
}

@media (max-width: 991.98px)  { .mia-logo { width: 100px; } .mia-logo-wrapper { border-right: none; margin-right: 0; padding-right: 0; } }
@media (max-width: 767.98px) { .mia-logo { width: 90px; } }
@media (max-width: 575.98px) {
  .desktop-company-name { display: none; }
  .mobile-company-name  { display: inline; font-size: 0.9rem; letter-spacing: -0.01em; }
  .company-name-wrapper { max-width: 110px; }
  .mia-logo { width: 85px; }
  .mia-logo-wrapper { padding-right: 8px; margin-right: 8px; }
}
@media (max-width: 359.98px) {
  .mia-logo { width: 70px; }
  .company-name-wrapper { max-width: 75px; }
}
</style>
